/* eslint-disable react/prop-types */
import React, { FC, useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router-dom';
import useStyles from './styles';
import BulkConfig from '../bulk-config';
import PendingCommandReport from '../pending-command-report';

interface ConfigAdminAccordionsProperties {
    onActionTypeChange: (actionType: string) => void;
    setScheduleCommandResponse: (response: any) => void;
    scheduleCommandResponse?: any;
    onAccordionClose?: () => void;
}

const ConfigAdminAccordions: FC<ConfigAdminAccordionsProperties> = ({
    onActionTypeChange,
    setScheduleCommandResponse,
    scheduleCommandResponse,
    onAccordionClose,
}) => {
    const classes = useStyles();
    const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(null);
    const location = useLocation();

    useEffect(() => {
        setOpenAccordionIndex(null);
    }, [location.pathname]);

    const toggleOpen = (index: number) => {
        if (openAccordionIndex === index) {
            setOpenAccordionIndex(null);
            if (onAccordionClose) onAccordionClose();
        } else {
            setOpenAccordionIndex(index);
        }
    };

    return (
        <div className={classes.accordions}>
            <Box>
                <Typography variant="h6" />
            </Box>
            <Box>
                <Accordion
                    id="BulkConfigPanel"
                    expanded={openAccordionIndex === 0}
                    onChange={() => toggleOpen(0)}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel-content"
                        id="panel-header"
                    >
                        <Typography variant="h5">Bulk Config</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {openAccordionIndex === 0 && (
                            <BulkConfig
                                onActionTypeChange={onActionTypeChange}
                                setScheduleCommandResponse={setScheduleCommandResponse}
                                scheduleCommandResponse={scheduleCommandResponse}
                            />
                        )}
                    </AccordionDetails>
                </Accordion>
                            <Accordion
                                id="PendingCommandReportPanel"
                                expanded={openAccordionIndex === 1}
                                onChange={() => toggleOpen(1)}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel-content"
                        id="panel-header"
                    >
                        <Typography variant="h5">Pending Command Response</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {openAccordionIndex === 1 && <PendingCommandReport />}
                    </AccordionDetails>
                </Accordion>
            </Box>
        </div>
    );
};

export default ConfigAdminAccordions;